// extracted by mini-css-extract-plugin
export default {"layout":"layout--zo7mG","back":"back--cSOm8","container":"container--y1UUB"};